import managerBlocksNavigationComponentUrl from './managerBlocksNavigationComponent.html';

class ManagerBlocksCtrl {
  constructor(Authentication, PersonaCollection) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection });
  }

  $onInit() {
    this.user = this.Authentication.user;

    if (this.Authentication.user.isManager) {
      this.users = this.PersonaCollection.allUsers.filter((u) => u.active);
      this.groups = this.PersonaCollection.groups;
      this.locations = this.PersonaCollection.locations;
      this.positions = this.PersonaCollection.positions;
      this.tags = this.PersonaCollection.tags;
    }

    this.deregisterPersonaWatch = this.PersonaCollection.onChange(() => {
      this.users = this.PersonaCollection.allUsers.filter((u) => u.active);
    });
  }

  $onDestroy() {
    if (this.deregisterPersonaWatch) {
      this.deregisterPersonaWatch();
    }
  }
}

export default {
  templateUrl: managerBlocksNavigationComponentUrl,
  controllerAs: 'ctrl',
  controller: ManagerBlocksCtrl,
};
